module.exports = __webpack_public_path__ + "static/img/WXShare.51b64f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/Activity/Tips/WXShare.png
// module id = 10
// module chunks = 17 18